/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type LeaderboardResult_getWMSmallBusinessLeaderboard$ref: FragmentReference;
declare export opaque type LeaderboardResult_getWMSmallBusinessLeaderboard$fragmentType: LeaderboardResult_getWMSmallBusinessLeaderboard$ref;
export type LeaderboardResult_getWMSmallBusinessLeaderboard = {|
  +getWMSmallBusinessLeaderboard: ?{|
    +code: ?number,
    +message: ?string,
    +data: ?{|
      +number_of_guests: ?number,
      +guests: ?$ReadOnlyArray<?{|
        +_id: ?string,
        +guest_name: ?string,
        +fantasy_points: ?number,
        +score: ?number,
      |}>,
    |},
  |},
  +$refType: LeaderboardResult_getWMSmallBusinessLeaderboard$ref,
|};
export type LeaderboardResult_getWMSmallBusinessLeaderboard$data = LeaderboardResult_getWMSmallBusinessLeaderboard;
export type LeaderboardResult_getWMSmallBusinessLeaderboard$key = {
  +$data?: LeaderboardResult_getWMSmallBusinessLeaderboard$data,
  +$fragmentRefs: LeaderboardResult_getWMSmallBusinessLeaderboard$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "LeaderboardResult_getWMSmallBusinessLeaderboard",
  "type": "Query",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "filter",
      "type": "fantasyFilterType",
      "defaultValue": {
        "leaderboard_access": "String",
        "guest_name": null,
        "option_name": null
      }
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "getWMSmallBusinessLeaderboard",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "filter",
          "variableName": "filter"
        }
      ],
      "concreteType": "smallBusinessDraftLeaderBoardType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "code",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "message",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "data",
          "storageKey": null,
          "args": null,
          "concreteType": "smallBusinessDraftLeaderBoardDataType",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "number_of_guests",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "guests",
              "storageKey": null,
              "args": null,
              "concreteType": "front_events_guest",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "_id",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "guest_name",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "fantasy_points",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "score",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'f38c76762c9b1ff0247df0ea3051595e';
module.exports = node;
